<!-- <nav tuiTabBar class="tabs fixed-bottom" [(activeItemIndex)]="activeItemIndex">
    <button *ngFor="let item of items" tuiTabBarItem type="button" [badge]="item.badge" [icon]="item.icon"
        (click)="onClick(item)" [routerLink]="item.link">
        {{ item.text }}
    </button>
</nav> -->
<ng-container *transloco="let t">
    <nav tuiTabBar class="tabs fixed-bottom" [(activeItemIndex)]="activeItemIndex">
        <button tuiTabBarItem type="button" icon="@tui.flask-conical" [routerLink]="ROUTES_CONST.START">
            {{ t('menu.whoAmI') }}
        </button>
        <button tuiTabBarItem type="button" icon="@tui.graduation-cap" [routerLink]="ROUTES_CONST.TRAINING">
            {{ t('menu.learning') }}
        </button>
        <!-- <button tuiTabBarItem type="button" icon="@tui.message-circle" [routerLink]="ROUTES_CONST.EGO_CHAT">
            {{ t('menu.egoChat') }}
        </button> -->
        <button tuiTabBarItem type="button" icon="@tui.ticket" [routerLink]="ROUTES_CONST.PRACTICE">
            {{ t('menu.practice') }}
        </button>
        <button tuiTabBarItem type="button" icon="@tui.settings" [routerLink]="ROUTES_CONST.SETTINGS">
            {{ t('menu.profile') }}
        </button>
    </nav>
</ng-container>
